import React,{useContext} from "react"
import { ControlledCheckBox } from '../../Core/Form/CheckBox';
import { useFormContext } from "react-hook-form";
import { generateNewAirport } from "../../../context/QuoteContext/actions";
import { QuoteContextStore } from '../../../context/QuoteContext/QuoteContext';

const AirportNotFoundCheckbox = () => {
    const { reset, getValues } = useFormContext();
    const {locked_quote} = useContext(QuoteContextStore)

    const handleCheckboxChange = (checked) => {
        if(checked) return;
        reset({...generateNewAirport(), state: getValues()['state'], airport_not_found: false});
    }

    return (
        <ControlledCheckBox onChange={handleCheckboxChange} name="airport_not_found" label="Can't find my airport on the list" disabled={locked_quote}/>
    )
}

export default AirportNotFoundCheckbox;